// extracted by mini-css-extract-plugin
export default {"tjyd":"index_tjyd_1S3GN","shadow":"index_shadow_nPs00","masked-animation":"index_masked-animation_aPIpT"};